// Keep this because of nativeApplicationVersion in SettingsFooter.native
export const SettingsFooter = () => {
  return null;
};